import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { SubmissionError } from 'redux-form'

import LoginForm from 'forms/LoginForm'
import Paper from 'components/Paper'
import Center from 'layout/Center'

import styles from './index.css'

import handleFormErrors from 'utils/handleFormErrors'

import AuthAPI from 'api/AuthAPI'
import { setToken, setMe, logout } from 'utils/auth'


@withRouter
export default class Login extends React.Component {
  
  static propTypes = {
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  async submit(values) {
    try {
      const {status, response} = await AuthAPI.login(values)
      if (status == 404 || status == 400) {
        throw new SubmissionError({ password: "Wrong email or password" })
      }
      if (response.token) {
        setToken(response.token)
        setMe(response.user)
        this.props.history.push('/dashboard')
      }
    } catch (e) {
      logout()
      throw e
    }
  }

  render() {
    return (
      <Center>
        <Paper>
          <LoginForm 
            form={'LoginForm'}
            onSubmit={this.submit}/>
        </Paper>
      </Center>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Login/index.jsx